export default "__VITE_ASSET__BucZExvI__"